import { render, staticRenderFns } from "./MsisdnPhoneInput.vue?vue&type=template&id=0994e357&"
import script from "./MsisdnPhoneInput.vue?vue&type=script&lang=js&"
export * from "./MsisdnPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports